import React, { useEffect, useRef, useState } from "react";
import reel from "../../../../../assets/images/Event-2025/reel-2.png";
import reelWaterMobile from "../../../../../assets/images/Event-2025/reel-water-mobile.png";
import attemptCoin from "../../../../../assets/images/Event-2025/attempt-coin.svg";
import playNow from "../../../../../assets/images/Event-2025/play-now.png";
import styled from "styled-components";
import LotoReel from "./LotoReel";
import superAttemptIcon from "../../../../../assets/images/Event-2025/super-attempt-coin.svg";
import {
  curStateAccount,
  curStateEventThingyan2025,
} from "../../../../../Redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { postDataApi } from "../../../../../config/service";
import API_PATH from "../../../../../config/API_PATH";
import {
  ID_GIFT_PLAY_LOTO,
  POPUP_VARIANT_EVENT_THINGYAN_2025 as VARIANT,
} from "../../../../../helper/const";
import { getTurnRemain } from "../../../../../Redux/futures/account/actions";
import {
  setDataPopupError,
  setDataSpinLeft,
} from "../../../../../Redux/futures/thingyan-2025/action";
import PopupCongrats from "../Popup/PopupCongrats";
import PopupError from "../Popup/PopupError";
import { useNavigate } from "react-router";
import PATH from "../../../../../config/PATH";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { ID_PRIZE } from "../DefineData";
import { setOpenPopupLogin } from "../../../../../Redux/futures/mini-game/action";

const dataStylePopup = [ID_PRIZE.prize_5, ID_PRIZE.prize_6, ID_PRIZE.prize_8];
function Reel({ setIsShowPopupZeroSpin }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectorAccount = useSelector(curStateAccount);
  const [isStart, setIsStart] = useState(false);
  const [isOpenPopupGift, setIsOpenPopupGift] = useState(false);
  const [dataApi, setDataApi] = useState(null);
  const timeoutId = useRef(null);
  const dataSpinApiRedux = useSelector(
    curStateEventThingyan2025
  )?.configEventThingyan;
  const dataSpinSet = useSelector(curStateEventThingyan2025)?.dataSpinLeft;
  const isPlayAttemptSuper = useRef(false);

  const dataSpin = !_.isEmpty(dataSpinSet)
    ? dataSpinSet
    : dataSpinApiRedux || {};

  const dataPopup = useRef({
    variant: null,
  });

  useEffect(() => {
    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
    };
  }, [timeoutId]);

  const showItemAttempts = () => {
    if (dataSpin.spin_left_free) {
      return (
        <>
          <img
            src={attemptCoin}
            alt=""
            width={40}
            height={40}
            className="icon-coins"
          />
          <div className="attempts-number-wrapper">
            ကစားခွင့်
            <span className="attempts-number">
              {" "}{dataSpin.spin_left_free}{" "}
            </span>{" "}
            coin ကျန်ပါသည်
          </div>
        </>
      );
    }

    if (dataSpin.spin_left_super) {
      return (
        <>
          <img
            src={superAttemptIcon}
            alt=""
            width={40}
            height={40}
            className="icon-coins"
          />
          <div className="attempts-number-wrapper">
            {
              dataSpin.spin_left_super > 1 ? `${dataSpin.spin_left_super} SUPER coin ကျန်ရှိသည်။` : "SUPER coin  1 ခု ကျန်ရှိသည်။"
            }
            {/* SUPER {dataSpin.spin_left_super > 1 ? "coins" : "coin"}{" "}
            {dataSpin.spin_left_super} ခု ကျန်ပါသည်။ */}
          </div>
        </>
      );
    }

    return (
      <>
        <img
          src={attemptCoin}
          alt=""
          width={40}
          height={40}
          className="icon-coins"
        />
        <div className="attempts-number-wrapper">
          <span className="attempts-number">{dataSpin.spin_left || 0}</span>{" "}
          {dataSpin.spin_left > 1
            ? t("event_thingyan.home_page.coins_left").replace("coin", "coins")
            : dataSpin.spin_left === 1
            ? t("event_thingyan.home_page.coins_left").replace("coins", "coin")
            : "Coin မရှိပါ"}
        </div>
      </>
    );
  };

  const handleCancelPopup = () => {
    setIsOpenPopupGift(false);
  };

  const handlePlayLoto = async () => {
    // check user đăng nhập chưa
    if (!selectorAccount.userInfo) {
      return setOpenPopupLogin(true);
    }
    if (
      !dataSpin.spin_left_super &&
      !dataSpin.spin_left_free &&
      !dataSpin.spin_left
    ) {
      return setIsShowPopupZeroSpin(true);
    }
    isPlayAttemptSuper.current = false;
    // quay supper
    if (dataSpin.spin_left_super) {
      isPlayAttemptSuper.current = true;
    }

    const dataApi = (await postDataApi(API_PATH.thingyanPlayLoto)) || {};

    // lỗi api
    if (!dataApi || !dataApi?.data || !dataApi?.success) {
      return dispatch(
        setDataPopupError({
          isOpen: true,
          message: "",
        })
      );
    }

    setDataApi(dataApi);
    setIsStart(true);

    // set lượt quay redux
    const {
      spin_left = 0,
      spin_left_free = 0,
      spin_left_super = 0,
    } = dataApi.data || {};
    dispatch(setDataSpinLeft({ spin_left, spin_left_free, spin_left_super }));

    // hiển thị popup quà
    if (+dataApi.data?.award.id === ID_GIFT_PLAY_LOTO.add_spin) {
      dataPopup.current = {
        variant: VARIANT.congratsCoin,
        dataCongratesApi: {
          ...dataApi.data.award,
          missionName: t("event_thingyan.pop_up.from Water Blessing Reel"),
          isReel: true
        },
      };
    }

    if (+dataApi.data?.award.id === ID_GIFT_PLAY_LOTO.good_luck) {
      dataPopup.current = {
        variant: VARIANT.goodLuck,
        dataCongratesApi: dataApi.data.award,
      };
    }

    if (+dataApi.data?.award.id === ID_GIFT_PLAY_LOTO.bid_free) {
      dataPopup.current = {
        variant: VARIANT.congratsBid,
        dataCongratesApi: dataApi.data.award,
        handleActionBtn: () => navigate(`${PATH.BID}/running`),
        isReel: true
      };
      dispatch(getTurnRemain({}));
    }

    if (+dataApi.data?.award.id === ID_GIFT_PLAY_LOTO.puzzle_piece) {
      dataPopup.current = {
        variant: VARIANT.congratsPiece,
        dataCongratesApi: dataApi.data.award,
      };
    }

    const id = setTimeout(() => {
      setIsStart(false);
      setIsOpenPopupGift(true);
    }, 5000);
    timeoutId.current = id;
  };

  return (
    <ReelContainer>
      <div
        className={`${
          _.includes(dataStylePopup, dataApi?.data?.award?.obj_puzzle_piece?.id)
            ? "container-style-popup"
            : ""
        }`}
      >
        {isOpenPopupGift &&
        dataPopup.current?.variant !== VARIANT.goodLuck &&
        dataPopup.current?.variant !== VARIANT.noAttempts ? (
          isPlayAttemptSuper.current ? (
            <PopupCongrats
              variant={VARIANT.surfacePiece}
              open={isOpenPopupGift}
              onCancel={handleCancelPopup}
              handleActionBtn={
                dataPopup.current?.handleActionBtn || handleCancelPopup
              }
              dataCongratesApi={dataPopup.current.dataCongratesApi}
              missionName={
                dataPopup.current?.dataCongratesApi?.missionName || ""
              }
              totalBid={dataPopup.current?.dataCongratesApi?.value || 0}
              getContainer={true}
            />
          ) : (
            <PopupCongrats
              variant={dataPopup.current.variant}
              open={isOpenPopupGift}
              onCancel={handleCancelPopup}
              handleActionBtn={
                dataPopup.current?.handleActionBtn || handleCancelPopup
              }
              dataCongratesApi={dataPopup.current.dataCongratesApi}
              missionName={
                dataPopup.current?.dataCongratesApi?.missionName || ""
              }
              totalBid={dataPopup.current?.dataCongratesApi?.value || 0}
              getContainer={true}
            />
          )
        ) : null}
        {isOpenPopupGift &&
        (dataPopup.current?.variant === VARIANT.goodLuck ||
          dataPopup.current?.variant === VARIANT.noAttempts) ? (
          <PopupError
            variant={dataPopup.current.variant}
            onCancel={handleCancelPopup}
            handleActionBtn={handleCancelPopup}
            getContainer={true}
          />
        ) : null}
        <div className="container-reel">
          <img src={reel} alt="reel" className="bg-reel" />
          <div className="detail-reel">
            <AttemptContainer className="attempt">
              {showItemAttempts()}
            </AttemptContainer>
          </div>
          <img src={reelWaterMobile} alt="reel" className="reel-water" />
          <div className="reel-icons">
            <LotoReel
              isStart={isStart}
              dataCongratesApi={dataPopup.current.dataCongratesApi}
            />
          </div>
          <PlayNowButton
            onClick={handlePlayLoto}
            style={{ pointerEvents: `${isStart ? "none" : ""}` }}
          >
            <img src={playNow} alt="playnow" className="play-now-btn" />
          </PlayNowButton>
        </div>
      </div>
    </ReelContainer>
  );
}

const ReelContainer = styled.div`
  .container-style-popup {
    .title-logo {
      margin-top: 0;
      max-height: 100px;
    }

    .ant-modal-content .popup-content__title-text {
      line-height: 25px;
    }
    .ant-modal-content .shrikhand.medium {
      line-height: 32px;
      font-size: 28px;
    }
  }
  .container-reel {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;

    .reel {
      position: relative;
      z-index: -1;
    }

    .reel-water {
      object-fit: contain;
      position: absolute;
      width: 100%;
    }

    .reel-icons {
      display: flex;
      position: absolute;
      gap: 64px;
      top: 50%;
      left: 50%;
      bottom: 0;
      transform: translate(-49%, -90%);
      height: fit-content;
      width: 100%;
      justify-content: center;
      align-items: center;

      .leaf-icon,
      .bid-icon,
      .puzzle-icon {
        position: relative;
        height: fit-content;
      }

      .puzzle-icon {
        left: 10px;
      }
    }

    @media (min-width: 1400px) {
      padding-top: 40px;
      .bg-reel {
        height: 699px;
        width: 850px;
        margin: 0 auto;
      }
      .attempt {
        top: 120px;
      }
    }

    @media (max-width: 1400px) {
      padding-top: 40px;
      .bg-reel {
        height: 592px;
        width: 720px;
        margin: 0 auto;
      }

      .attempt {
        top: 105px;
      }
    }

    @media (max-width: 1200px) {
      .reel-icons {
        gap: 50px;
      }

      padding-top: 40px;
      .attempt {
        top: 94px;
      }
      .bg-reel {
        height: 510px;
        width: 620px;
        margin: 0 auto;
      }
    }

    @media (max-width: 1075px) {
      .reel-icons {
        gap: 28px;
      }

      padding-top: 40px;
      .attempt {
        top: 88px;
      }
      .bg-reel {
        height: 469px;
        width: 570px;
        margin: 0 auto;
      }
    }

    @media (max-width: 992px) {
      .reel-icons {
        gap: 36px;
      }

      padding-top: 40px;
      .attempt {
        top: 94px;
      }
      .bg-reel {
        height: 510px;
        width: 620px;
        margin: 0 auto;
      }
    }

    @media (max-width: 768px) {
      padding-top: 40px;
      .attempt {
        top: 88px;
      }
      .bg-reel {
        height: 469px;
        width: 570px;
        margin: 0 auto;
      }
    }

    @media (max-width: 576px) {
      padding-top: 20px;
      .attempt {
        top: 62px;
      }
      .bg-reel {
        height: 395px;
        width: 480px;
        margin: 0 auto;
      }
    }

    @media (max-width: 492px) {
      padding-top: 20px;
      .attempt {
        top: 49px;
        width: max-content;
      }
      .bg-reel {
        height: 313px;
        width: 380px;
        margin: 0 auto;
      }
    }

    @media (max-width: 412px) {
      padding-top: 30px;
      margin-top: -8px;
      .attempt {
        top: 56px;
      }
      .bg-reel {
        height: 292px;
        width: 355px;
        margin: 0 auto;
      }
    }
    @media (max-width: 375px) {
      padding-top: 30px;

      .bg-reel {
        height: 275px;
        width: 320px;
        margin: 0 auto;
      }

      .detail-reel {
        width: 100%;
      }

      .attempt {
        top: 54px;
      }
      .reel-icons {
        & > img {
          width: 55px;
        }

        .leaf-icon {
          width: 40px;
        }
      }
    }

    @media (max-width: 320px) {
      .reel-icons {
        gap: 12px;
      }
    }
  }
`;

const AttemptContainer = styled.div`
  position: absolute;
  top: 12%;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 8px;

  .attempts-number-wrapper {
    font-weight: bold;
    color: #fff;
    font-size: 20px;

    .attempts-number {
      color: rgba(255, 191, 31, 1);
      font-weight: bold;
    }
  }

  @media (max-width: 1152px) {
    top: 12%;
  }
  @media (max-width: 1080px) {
    top: 11%;
  }
  @media (max-width: 700px) {
    top: 10%;
  }
  @media (max-width: 652px) {
  }

  @media (max-width: 576px) {
    top: calc(10.5%);

    .icon-coins {
      width: 32px;
      height: 32px;
    }

    .attempts-number-wrapper {
      font-size: 16px;
    }
  }

  @media (max-width: 492px) {
    top: 10%;
    & > img {
      width: 25px;
      height: 25px;
    }
    .attempts-number-wrapper {
      font-size: 16px;
    }
  }

  @media (max-width: 440px) {
    top: 10.7%;
  }

  @media (max-width: 425px) {
    top: 12%;
    & > img {
      width: 25px;
      height: 25px;
    }
    .attempts-number-wrapper {
      font-size: 15px;
    }
  }

  @media (max-width: 392px) {
    top: 13%;
  }

  @media (max-width: 375px) {
    top: 11%;
  }

  @media (max-width: 350px) {
    .attempts-number-wrapper {
      font-size: 14px;
    }
  }

  @media (max-width: 320px) {
    top: 13%;
    & > img {
      width: 18px;
      height: 18px;
    }
  }
`;
const PlayNowButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -70%);
  cursor: pointer;
  max-width: 354px;

  @media (max-width: 1400px) {
    bottom: -20px;
    max-width: 310px;
    transform: translate(-50%, -85%);
  }

  @media (max-width: 1200px) {
    max-width: 250px;
    bottom: -10px;
  }

  @media (max-width: 1075px) {
    max-width: 220px;
    bottom: -5px;
  }

  @media (max-width: 992px) {
    bottom: -15px;
    max-width: 260px;
  }

  @media (max-width: 768px) {
    transform: translate(-50%, -75%);
  }

  @media (max-width: 576px) {
    max-width: 200px;
    bottom: 10px;
  }

  @media (max-width: 492px) {
    bottom: 0;
    max-width: 160px;
  }

  @media (max-width: 652px) {
    & > img {
      width: 275px;
    }
  }

  @media (max-width: 576px) {
    transform: translate(-50%, -60%);
    & > img {
      width: 250px;
    }
  }

  @media (max-width: 492px) {
    transform: translate(-50%, -65%);
    & > img {
      width: 200px;
    }
  }

  @media (max-width: 412px) {
    transform: translate(-50%, -55%);
  }

  @media (max-width: 375px) {
    transform: translate(-50%, -45%);
    & > img {
      width: 180px;
    }
  }

  @media (max-width: 335px) {
    transform: translate(-50%, -55%);
  }

  @media (max-width: 320px) {
    & > img {
      width: 150px;
    }
  }
`;

export default Reel;
